<template>
  <div class="account-pages mt-5 mb-5">
    <div class="container"><router-view /></div>
  </div>
</template>

<script>
export default {
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
  }
}
</script>